var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showType == 'form-builder')?_c('b-form-group',{style:(_vm.properties.style),attrs:{"description":_vm.properties.description,"label":_vm.properties.label}},[_c('b-form-select',{attrs:{"options":[]},model:{value:(_vm.controlValue),callback:function ($$v) {_vm.controlValue=$$v},expression:"controlValue"}})],1):_vm._e(),(_vm.showType == 'properties')?_c('div',[_c('document-picker-v1-properties',{attrs:{"formId":_vm.formId}})],1):_vm._e(),(_vm.showType == 'form-submitter')?_c('b-form-group',{staticStyle:{"font-size":"14px"},style:(_vm.properties.style),attrs:{"description":_vm.superComputeFormSubmitterValue({
        elementId: this.id,
        property: 'description',
        value: _vm.properties.description,
        defaultValue: '',
        form: this.form
      }),"label":_vm.superComputeFormSubmitterValue({
        elementId: this.id,
        property: 'label',
        value: _vm.properties.label,
        defaultValue: '',
        form: this.form
      }),"hidden":_vm.computedHidden}},[_c('v-select',{staticStyle:{"font-size":"14px"},attrs:{"options":_vm.formattedFormOptions,"clearable":false},model:{value:(_vm.controlValue),callback:function ($$v) {_vm.controlValue=$$v},expression:"controlValue"}})],1):_vm._e(),(_vm.showType == 'form-viewer')?_c('b-form-group',{attrs:{"label":_vm.superComputeFormSubmitterValue({
        elementId: this.id,
        property: 'label',
        value: _vm.properties.label,
        defaultValue: '',
        form: this.form
      })}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }